module.exports = __webpack_public_path__ + "static/media/digital-features-icon.8b251a41.svg";